// extracted by mini-css-extract-plugin
module.exports = {"container":"Placeholder_container__UpsjB","text-center":"Placeholder_text-center__7RAhG","emoji":"Placeholder_emoji__MK4up","spacer":"Placeholder_spacer__R3SNx"};